import React from 'react';
import styled from 'styled-components';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { HelpTooltip } from "../../components/HelpTooltip";

const MUILabelCheckboxContainer = styled.div`
  margin-left: 5px;
  .MuiFormControlLabel-root {
    margin-right: 0px;
  }
  img {
    margin-top: -3px;
  }
`;

interface Iprops {
  label: string;
  name?: string;
  disabled?: boolean;
  isChecked?: boolean;
  tooltipContent?: {
    title: string;
    text: string;
  };
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const MUILabelCheckbox: React.FC<Iprops> = ({ label, name, disabled, isChecked, tooltipContent, onChange }) => {
  return (
    <MUILabelCheckboxContainer>
      <HelpTooltip {...tooltipContent} color={!disabled ? 'black': undefined}>
        <FormControlLabel
          label={label}
          control={
            <Checkbox
              checked={isChecked}
              onChange={onChange}
              name={name}
              disabled={disabled}
            />
          }
        />
      </HelpTooltip>
    </MUILabelCheckboxContainer>
  );
};
